import { Pipe, PipeTransform } from '@angular/core';
import { MoneyTransaction } from '@zero/shared/util-models';

@Pipe({
  name: 'moneyTransactionStatus',
  standalone: true,
})
export class MoneyTransactionStatusPipe implements PipeTransform {
  public transform(value: MoneyTransaction): unknown {
    let ret = 'vorläufig';
    if (value.importMatchDate) {
      ret = 'gebucht';
    }
    if (value.matchedImportStorno) {
      ret = 'storniert';
    }

    return ret;
  }
}
